var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"privilege"},_vm._l((_vm.list),function(text,index){return _c('div',{key:index,staticClass:"icon_box"},[_c('i',{class:("icon icon_" + (_vm.imgIdMap[text]))}),_c('span',[_vm._v(_vm._s(text))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }